import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "text-caption" }
const _hoisted_4 = { class: "device-result" }
const _hoisted_5 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_class_picker = _resolveComponent("class-picker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("strong", null, "クラス選択", -1)),
              _createVNode(_component_class_picker, {
                classes: _ctx.classes,
                "onUpdate:modelValue": _ctx.selectClassName
              }, null, 8, ["classes", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.showQuit,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showQuit) = $event)),
                color: "primary",
                label: "退園済み"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_data_table, {
      class: "pt-4",
      items: _ctx.childrenWithDevices,
      headers: _ctx.childrenTableHeaders,
      "hide-default-footer": "",
      "items-per-page": -1,
      "item-key": "childId"
    }, {
      [`item.name`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(`${item.child.lastName} ${item.child.firstName}`), 1)
      ]),
      [`item.class`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.getClassName(item.child)), 1)
      ]),
      [`item.sensors`]: _withCtx(({ item }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.devices, (device) => {
          return (_openBlock(), _createBlock(_component_v_chip, {
            close: "",
            key: device.sid,
            "onClick:close": ($event: any) => (_ctx.remove(item.child.childId, device.sid))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(device.sid), 1)
            ]),
            _: 2
          }, 1032, ["onClick:close"]))
        }), 128))
      ]),
      [`item.edit`]: _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          color: "primary",
          variant: "flat",
          id: item.child.childId,
          onClick: () => _ctx.selectedChild = item.child
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" 追加 ", -1)
          ]))]),
          _: 1
        }, 8, ["id", "onClick"])
      ]),
      _: 2
    }, 1032, ["items", "headers"]),
    _createVNode(_component_v_dialog, {
      value: _ctx.selectedChild !== null,
      "onClick:outside": _cache[1] || (_cache[1] = () => _ctx.selectedChild = null),
      "max-width": "720"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedChild)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "pa-4"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.selectedChild.lastName) + " " + _toDisplayString(_ctx.selectedChild.firstName), 1)
                ]),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('common_actions.readerInstruction')), 1),
                _createVNode(_component_v_row, { align: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" センサーID ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.detectedIdm), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "flat",
                          rounded: "",
                          onClick: _ctx.read
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode(" 読み取り ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.isRegistering)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary",
                      class: "my-4"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    block: "",
                    large: "",
                    disabled: !_ctx.detectedIdm || _ctx.isRegistering,
                    onClick: _ctx.register
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" 登録 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}